import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const STATIC_SITES_DELETED = 'STATIC_SITES_DELETED';

export const staticSitesDeleted = (id: number) => {
    return {
        type: STATIC_SITES_DELETED,
        id,
    };
};

export const deleteStaticSites = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(staticSitesDeleted(id));

        const response = await api.contentManagement.StaticSites.deleteStaticSites(id);

        if (!response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
